module.exports = __webpack_public_path__ + "img/Span-09.99f7dab6.jpg";